import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    Checkbox,
    TableContainer,
    Box,
    Modal,
    Button,
    Fade,
    Backdrop,
    CircularProgress,
    IconButton,
    Typography,
    Card,
    CardContent
} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import { DownloadOutlined } from '@ant-design/icons';
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import CloseIcon from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import FilterListIcon from "@material-ui/icons/FilterList";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "blue"
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        // "&:hover": { 
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
            backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const AutomationLeadDashboard = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [store, setStore] = useState([]);
    const [storeManual, setStoreManual] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [pivot, setPivot] = useState("")
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "", dateType: "leadAssignedDate" })
    const [sourceTypes, setSourceTypes] = useState([])
    const [selectedSourceOfLead, setSelectedSourceOfLead] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', "Oct", "Nov", "Dec"];
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [automationLeadTableCsvData, setAutomationLeadTableCsvData] = useState([]);
    const automationLeadTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [manualLeadTableCsvData, setManualLeadTableCsvData] = useState([]);
    const manualLeadTableCsvButtonRef = useRef(null);
    const [triggerManualDownload, setTriggerManualDownload] = useState(false);
    const [automationLeadBreakdownTableCsvData, setAutomationLeadBreakdownTableCsvData] = useState([]);
    const automationLeadBreakdownTableCsvButtonRef = useRef(null);
    const [triggerBreakdownDownload, setTriggerBreakdownDownload] = useState(false);
    const [tableCsvData, setTableCsvData] = useState([]);
    const tableCsvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Contact No']

    const [modalLoading, setModalLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const rowsPerPage = 50;

    const [automationLoading, setAutomationLoading] = useState(false);
    const [manualLoading, setManualLoading] = useState(false);
    const [breakdownLoading, setBreakdownLoading] = useState(false);

    const displayDate = (month, year) => {
        const shortYear = year.toString().slice(-2); // Get the last two digits of the year

        // Check if the month includes a `/`, indicating multiple months
        if (typeof month === 'string' && month.includes('/')) {
            const monthCodes = month.split('/').map(code => parseInt(code)); // Convert each to an integer
            monthCodes.sort((a, b) => a - b); // Sort the month codes in ascending order
            const monthNames = monthCodes.map(code => months[code]); // Convert each code to month name
            return `${monthNames.join('/')} - ${shortYear}`; // Join with a slash and append the short year
        } else {
            // Single month case
            return `${months[parseInt(month)]} - ${shortYear}`;
        }
    };

    const clickableCellStyle = (index) => ({
        textAlign: "center",
        cursor: "pointer",
        color: index !== store.length - 1 ? "#1C375D" : "#355025",
        textDecoration: "underline",
        fontWeight: index !== store.length - 1 ? 'normal' : 'bolder',
        background: "white"
    });

    const grandTotalCellStyle = {
        textAlign: "center",
        cursor: "pointer",
        color: "#004d40",
        textDecoration: "underline",
        fontWeight: "bolder",
        background: "white"
    };

    useEffect(() => {
        expCenters();
        locations();
        fetchUsersData();
        automationLeadSummary();
        manualLeadSummary();
        getSourceOfLeads();
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "_id", label: "Lead Id" },
        // { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        // { key: "clientNumber", label: "Number" },
        // { key: "clientEmail", label: "Email" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadType", label: "Lead Type" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "createdAt", label: "Created At" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "assignedPerson", label: "Assigned To" },
        { key: "sourceOfLead", label: "Source of Lead" },
        { key: "projectNeeds", label: "Project Needs" },
        { key: "minimumBudget", label: "Minimum Budget" },
        { key: "startInterior", label: "Start Interior by" },
        // { key: "tokenPercent", label: "Token % Received" },
    ];



    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    _id: popMonthData[i]?._id || "NA",
                    projectCode: popMonthData[i]?.erpProjectNo || "N/A",
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerName,
                    // clientNumber: popMonthData[i]?.customerNumber,
                    // clientEmail: popMonthData[i]?.customerEmail,
                    currentStage: popMonthData[i]?.currentStage,
                    leadType: popMonthData[i]?.leadType,
                    location: popMonthData[i]?.cityName,
                    expCtrName: popMonthData[i]?.experienceCenterName,
                    createdAt: popMonthData[i]?.createdAt
                        ? moment(popMonthData[i]?.createdAt).format("DD-MM-YYYY")
                        : "-",
                    leadAssignedDate: popMonthData[i]?.leadAssignedDate
                        ? moment(popMonthData[i]?.leadAssignedDate).format("DD-MM-YYYY")
                        : "-",
                    assignedPerson: popMonthData[i]?.assignedPerson,
                    sourceOfLead: popMonthData[i]?.sourceOfLead,
                    projectNeeds: popMonthData[i]?.projectNeeds,
                    minimumBudget: popMonthData[i]?.threeLakhsSuits,
                    startInterior: popMonthData[i]?.startProjectBy,
                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            // downloadExcel();
        } catch (error) {

            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // Trigger CSV download when data is ready for main table
    useEffect(() => {
        if (triggerDownload && automationLeadTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (automationLeadTableCsvButtonRef.current?.link) {
                    try {
                        automationLeadTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerDownload(false);
                } else {
                    setTimeout(() => {
                        if (automationLeadTableCsvButtonRef.current?.link) {
                            automationLeadTableCsvButtonRef.current.link.click();
                            setTriggerDownload(false);
                        }
                    }, 200);
                }
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [triggerDownload, automationLeadTableCsvData]);

    // Trigger CSV download when data is ready for digital leads table
    useEffect(() => {
        if (triggerManualDownload && manualLeadTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (manualLeadTableCsvButtonRef.current?.link) {
                    try {
                        manualLeadTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerManualDownload(false);
                } else {
                    setTimeout(() => {
                        if (manualLeadTableCsvButtonRef.current?.link) {
                            manualLeadTableCsvButtonRef.current.link.click();
                            setTriggerManualDownload(false);
                        }
                    }, 200);
                }
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [triggerManualDownload, manualLeadTableCsvData]);

    // Trigger CSV download when data is ready for breakdown table
    useEffect(() => {
        if (triggerBreakdownDownload && automationLeadBreakdownTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (automationLeadBreakdownTableCsvButtonRef.current?.link) {
                    try {
                        automationLeadBreakdownTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerBreakdownDownload(false);
                } else {
                    setTimeout(() => {
                        if (automationLeadBreakdownTableCsvButtonRef.current?.link) {
                            automationLeadBreakdownTableCsvButtonRef.current.link.click();
                            setTriggerBreakdownDownload(false);
                        }
                    }, 200);
                }
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [triggerBreakdownDownload, automationLeadBreakdownTableCsvData]);

    // Function to generate CSV data for automation lead main table
    const generateAutomationLeadTableCsvData = () => {
        try {
            if (!store || store.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "CreatedAt Month And Year": "",
                "Lead Received": "",
                "Real": "",
                "NTBC -Hold": "",
                "Hold": "",
                "Junk": "",
                "To Be Called": ""
            };
            csvRows.push(headerRow);

            // Add data rows
            store.forEach((ele, index) => {
                const monthYear = index === store.length - 1
                    ? ele?._id?.year
                    : `${months[ele?.month]}-${ele?._id?.year % 100}`;

                const row = {
                    "CreatedAt Month And Year": monthYear,
                    "Lead Received": ele.leadReceivedCount || 0,
                    "Real": ele.realLeadsCount || 0,
                    "NTBC -Hold": ele.ntbcHoldCount || 0,
                    "Hold": ele.holdCount || 0,
                    "Junk": ele.junkCount || 0,
                    "To Be Called": ele.toBeCalledCount || 0
                };

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating automation lead table CSV:", error);
            return [];
        }
    };

    const generateManualLeadTableCsvData = () => {
        try {
            if (!storeManual || storeManual.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "CreatedAt Month And Year": "",
                "Lead Received": "",
                "Real": "",
                "NTBC -Hold": "",
                "Hold": "",
                "Junk": "",
                "To Be Called": ""
            };
            csvRows.push(headerRow);

            // Add data rows
            storeManual.forEach((ele, index) => {
                const monthYear = index === storeManual.length - 1
                    ? ele?._id?.year
                    : `${months[ele?.month]}-${ele?._id?.year % 100}`;

                const row = {
                    "CreatedAt Month And Year": monthYear,
                    "Lead Received": ele.leadReceivedCount || 0,
                    "Real": ele.realLeadsCount || 0,
                    "NTBC -Hold": ele.ntbcHoldCount || 0,
                    "Hold": ele.holdCount || 0,
                    "Junk": ele.junkCount || 0,
                    "To Be Called": ele.toBeCalledCount || 0
                };

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating automation lead table CSV:", error);
            return [];
        }
    };

    // Function to generate CSV data for automation lead breakdown table
    const generateAutomationLeadBreakdownTableCsvData = () => {
        try {
            if (!store || store.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row
            const headerRow = {
                "CreatedAt Month And Year": "",
                "Real Leads": "",
                "Automation Leads": "",
                "BotWot Leads": ""
            };
            csvRows.push(headerRow);

            // Add data rows
            store.forEach((ele, index) => {
                const monthYear = index === store.length - 1
                    ? ele?._id?.year
                    : `${months[ele?.month]}-${ele?._id?.year % 100}`;

                const automationLeads = ele.realLeadsData?.filter(
                    (lead) => lead.automationLead === true && !lead.botWot
                ) || [];

                const botWotLeads = ele.realLeadsData?.filter(
                    (lead) => lead.automationLead === true && lead.botWot
                ) || [];

                const row = {
                    "CreatedAt Month And Year": monthYear,
                    "Real Leads": ele.realLeadsCount || 0,
                    "Automation Leads": automationLeads.length || 0,
                    "BotWot Leads": botWotLeads.length || 0
                };

                csvRows.push(row);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating automation lead breakdown table CSV:", error);
            return [];
        }
    };

    const tableHeaders = [
        { key: "serialNo", label: "Sl. No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadType", label: "Lead Type" },
        { key: "location", label: "City" },
        { key: "expCtrName", label: "Exp. Ctr. Name" },
        { key: "createdAt", label: "CreatedAt Date" },
        { key: "leadAssignedDate", label: "LeadAssigned Date" },
        { key: "assignedPerson", label: "Assigned To" },
        { key: "sourceOfLead", label: "Source" },
    ];

    const tableCsvDownloadHandler = () => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    leadNumber: popMonthData[i]?.lead_no || "N/A",
                    clientName: popMonthData[i]?.customerName || "N/A",
                    currentStage: popMonthData[i]?.currentStage || "N/A",
                    leadType: popMonthData[i]?.leadType || "N/A",
                    location: popMonthData[i]?.cityName || "N/A",
                    expCtrName: popMonthData[i]?.experienceCenterName || "N/A",
                    createdAt: popMonthData[i]?.createdAt
                        ? moment(popMonthData[i]?.createdAt).format("DD-MM-YYYY")
                        : "-",
                    leadAssignedDate: popMonthData[i]?.leadAssignedDate
                        ? moment(popMonthData[i]?.leadAssignedDate).format("DD-MM-YYYY")
                        : "-",
                    assignedPerson: popMonthData[i]?.assignedPerson || "N/A",
                    sourceOfLead: popMonthData[i]?.sourceOfLead || "N/A",
                };
                csvArray.push(obj);
            }
            setTableCsvData(csvArray);
            setTimeout(() => {
                tableCsvButtonRef.current.link.click();
            });
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }


    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter(user => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const automationLeadSummary = async (addSources, addLocation, addExpCenter, selectedSearchType, searchInput) => {

        setAutomationLoading(true);
        setBreakdownLoading(true);

        let sourcesData = addSources?.map((el) => el.sourceType)
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)

        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedSources: sourcesData ? sourcesData : "",
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }

        try {
            let response = await HttpService.automationLeadSummaryDashboard(obj);
            setStore(response.data.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        setAutomationLoading(false);
        setBreakdownLoading(false);
    }

    const manualLeadSummary = async (addSources, addLocation, addExpCenter, selectedSearchType, searchInput) => {

        setManualLoading(true);

        let sourcesData = addSources?.map((el) => el.sourceType)
        let locationData = addLocation?.map((el) => el._id)
        let expCenterData = addExpCenter?.map((el) => el._id)

        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedSources: sourcesData ? sourcesData : "",
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.experienceCenterId,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }

        try {
            let response = await HttpService.manualLeadSummaryDashboard(obj);
            setStoreManual(response.data.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        setManualLoading(false);
    }

    const formatNumberToTwoDecimalPlaces = (value) => {
        return parseFloat(value).toFixed(2);
    }

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = async () => {
        automationLeadSummary(selectedSourceOfLead, selectedLocation, selectedExperienceCenter, selectedSearchType, searchInput)
        manualLeadSummary(selectedSourceOfLead, selectedLocation, selectedExperienceCenter, selectedSearchType, searchInput)

    }

    const handleSelectChange = async (event) => {
        setSelectedValue(event.target.value);
        let locationData = selectedLocation?.map((el) => el._id)
        let expCenterData = selectedExperienceCenter?.map((el) => el._id)
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            dateType: storeDateFilter.dateType,
            selectedLocation: locationData ? locationData : "",
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            userExpCenter: userDetails.selectedExpCenter,
            userLocation: userDetails.selectedLocation,
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        props.setLoading(true);
        try {
            let response = await HttpService.automationLeadSummaryDashboard(obj);
            setStore(response.data.data);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (value) => {
        automationLeadSummary(selectedSourceOfLead, selectedLocation, selectedExperienceCenter, selectedSearchType, searchInput)
        manualLeadSummary(selectedSourceOfLead, selectedLocation, selectedExperienceCenter, selectedSearchType, searchInput)
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const fetchUsersData = async () => {
        let obj = {}
        if (userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.SalesUser)) {
            obj.role = ROLENAME.SalesUser
        } else if (userDetails.roles.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            obj.role = ROLENAME.DesignUser
        } else {
            obj.role = "ALL"
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error, "error")
        }
    }

    const handleMultipleSourceOfLead = (event, newValue) => {
        setSelectedSourceOfLead(newValue)
        handleSourceOfLead(newValue)
    }

    const handleSourceOfLead = async (newValue) => {
        props.setLoading(true);
        await automationLeadSummary(newValue, selectedLocation, selectedExperienceCenter, selectedSearchType, searchInput)
        await manualLeadSummary(newValue, selectedLocation, selectedExperienceCenter, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        handleExpData(newvalue)
    }

    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
        handleLocationData(newValue)
    }
    const handleLocationData = async (newvalue) => {
        props.setLoading(true);
        await automationLeadSummary(selectedSourceOfLead, newvalue, selectedExperienceCenter, selectedSearchType, searchInput)
        await manualLeadSummary(selectedSourceOfLead, newvalue, selectedExperienceCenter, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const getSourceOfLeads = async () => {
        try {
            const response = await HttpService.getLeadMaster();

            const uniqueSourceTypes = Array.from(
                new Map(
                    response.data
                        .map(item => [item.sourceType, item]) // key by sourceType
                ).values()
            );

            setSourceTypes(uniqueSourceTypes);
        } catch (error) {
            console.error(
                "Error fetching source of leads:",
                error?.response?.data || error.message
            );
        }
    };

    const dataBasedOnClick = async (data, text) => {
        setShowDetailedModal(true);
        setPivot(text);

        setModalLoading(true);

        // simulate API delay (remove if real API)
        setTimeout(() => {
            setPopMonthData(data);
            setModalLoading(false);
        }, 500);

        setPage(0);
    };

    const clearDateFilter = async () => {
        setSearchInput("")
        setSelectedSearchType("")
        automationLeadSummary(selectedSourceOfLead, selectedLocation, selectedExperienceCenter, "", "")
        manualLeadSummary(selectedSourceOfLead, selectedLocation, selectedExperienceCenter, "", "")
    }

    const handleExpData = async (newvalue) => {
        props.setLoading(true);
        await automationLeadSummary(selectedSourceOfLead, selectedLocation, newvalue, selectedSearchType, searchInput)
        await manualLeadSummary(selectedSourceOfLead, selectedLocation, newvalue, selectedSearchType, searchInput)
        props.setLoading(false);
    }

    const isMarketingAnalyst = userDetails.roles.some(
        (user) => user.name === ROLENAME.marketingAnalyst
    )

    const filteredData = popMonthData.filter((lead) =>
        (lead.lead_no + "").includes(search) ||
        (lead.customerId?.name || "").toLowerCase().includes(search.toLowerCase())
    );

    const paginatedData = filteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const handleCloseModal = () => {
        setShowDetailedModal(false);
        setPage(0);
        setSearch("")
    };

    return (
        <div className="App">
            <br />

            <Card
                style={{
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    marginBottom: "16px"
                }}
            >
                <CardContent style={{ padding: "20px" }}>

                    {/* HEADER */}
                    <Grid container alignItems="center" style={{ marginBottom: "15px" }}>
                        <FilterListIcon style={{ color: "#1C375D", marginRight: 8 }} />
                        <h2 style={{ margin: 0, fontWeight: 600, fontSize: "18px", color: "#1C375D" }}>
                            Filters
                        </h2>
                    </Grid>

                    {/* ROW 1 */}
                    <Grid container spacing={2} alignItems="flex-end">

                        {/* Source */}
                        <Grid item xs={2}>
                            <Autocomplete
                                multiple
                                value={selectedSourceOfLead}
                                onChange={handleMultipleSourceOfLead}
                                options={sourceTypes}
                                getOptionLabel={(option) => option.sourceType}
                                renderInput={(params) => (
                                    <TextField {...params} label="Source Type of Lead" variant="outlined" size="small" />
                                )}
                            />
                        </Grid>

                        {/* Exp Center */}
                        <Grid item xs={2}>
                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                onChange={handleMultipleExpData}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => (
                                    <TextField {...params} label="Experience Center" variant="outlined" size="small" />
                                )}
                            />
                        </Grid>

                        {/* Date Type */}
                        <Grid item xs={2}>
                            <TextField
                                select
                                label="Date Type"
                                name="dateType"
                                value={storeDateFilter.dateType}
                                onChange={storePivotDate}
                                fullWidth
                                variant="outlined"
                                size="small"
                            >
                                <MenuItem value="leadAssignedDate">Lead Assigned</MenuItem>
                                <MenuItem value="createdAt">Created</MenuItem>
                            </TextField>
                        </Grid>

                        {/* From */}
                        <Grid item xs={2}>
                            <TextField
                                type="date"
                                label="From Date"
                                name="startDate"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>

                        {/* To */}
                        <Grid item xs={2}>
                            <TextField
                                type="date"
                                label="To Date"
                                name="endDate"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>

                        {/* APPLY BUTTON (FIXED POSITION) */}
                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={handlePivotDateFilter}
                                style={{
                                    backgroundColor: "#F47E46",
                                    color: "#fff",
                                    height: "40px",
                                    borderRadius: "6px",
                                    textTransform: "none",
                                    fontWeight: 500
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    {/* ROW 2 */}
                    <Grid container spacing={2} style={{ marginTop: 15 }} alignItems="center">

                        {/* Search Type */}
                        <Grid item xs={3}>
                            <TextField
                                select
                                label="Search Type"
                                value={selectedSearchType}
                                onChange={(e) => handleSearchType(e.target.value)}
                                fullWidth
                                variant="outlined"
                                size="small"
                            >
                                {searchTypes?.map((el, i) => (
                                    <MenuItem key={i} value={el}>{el}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Search Input */}
                        <Grid item xs={5}>
                            <TextField
                                label="Search"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyDown={handleKeyDown}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>

                        {/* Search Button */}
                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                variant="contained"
                                disabled={!selectedSearchType || !searchInput}
                                onClick={() => handleSearch(searchInput.toUpperCase())}
                                style={{
                                    backgroundColor: "#F47E46",
                                    color: "#fff",
                                    height: "40px",
                                    borderRadius: "6px",
                                    textTransform: "none",
                                    fontWeight: 500,
                                    opacity: (!selectedSearchType || !searchInput) ? 0.5 : 1,
                                    cursor: (!selectedSearchType || !searchInput) ? "not-allowed" : "pointer"
                                }}
                            >
                                Search
                            </Button>
                        </Grid>

                        {/* Clear Button */}
                        <Grid item xs={2}>
                            <Button
                                fullWidth
                                variant="outlined"
                                onClick={clearDateFilter}
                                style={{ borderColor: "red", color: "red", height: "40px" }}
                            >
                                Clear
                            </Button>
                        </Grid>
                    </Grid>

                </CardContent>
            </Card>
            <br />

            <Paper
                elevation={3}
                style={{
                    padding: "20px",
                    borderRadius: "10px",
                    backgroundColor: "#fafafa",
                    marginTop: "20px"
                }}
            >

                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #e0e0e0",
                        paddingBottom: "10px",
                        marginBottom: "20px"
                    }}
                >
                    <h3
                        style={{
                            margin: 0,
                            fontWeight: 600,
                            color: "#1C375D",
                            letterSpacing: "0.5px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <AutorenewIcon style={{ fontSize: 22 }} />
                        Automation Leads {automationLoading && <CircularProgress size={18} />}
                    </h3>

                    <CSVLink
                        data={automationLeadTableCsvData}
                        filename={`Automation_Lead_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={automationLeadTableCsvButtonRef}
                        style={{ display: "none" }}
                    />

                    <Button
                        variant="contained"
                        startIcon={<DownloadOutlined />}
                        disabled={automationLoading}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            const csvData = generateAutomationLeadTableCsvData();

                            if (csvData.length > 0) {
                                setAutomationLeadTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.5rem 1.8rem",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: "0px 3px 8px rgba(0,0,0,0.15)"
                        }}
                    >
                        Download CSV
                    </Button>
                </div>

                {/* TABLE */}
                <TableContainer
                    style={{
                        maxHeight: "600px",
                        overflow: "auto"
                    }}
                    classes={{ root: classes.customTableContainer }}
                >
                    <Table style={{ minWidth: '600px' }}>
                        {/* Static Headers */}
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                            <StyledTableRow>
                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>
                                    Month And Year
                                </StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Lead Received</StyledTableCell>
                                {/* <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>WhatsApp Chat In Progress</StyledTableCell> */}
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Real</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>NTBC -Hold</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Hold</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Junk</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>To Be Called</StyledTableCell>
                                {/* <StyledTableCell className={classes.bordercolors} style={{ fontSize: '15px', textAlign: 'center' }}>
                                    Grand Total
                                </StyledTableCell> */}
                            </StyledTableRow>
                        </TableHead>
                        <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                            {automationLoading ? (
                                [...Array(2)].map((_, rowIdx) => (
                                    <StyledTableRow key={rowIdx}>
                                        {[...Array(7)].map((__, colIdx) => (
                                            <StyledTableCell key={colIdx}>
                                                <Skeleton variant="text" width="100%" style={{ backgroundColor: 'white' }} />
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))
                            ) : store.length > 0 ? (
                                store.map((ele, index) => (
                                    <StyledTableRow key={index}>
                                        {index === store.length - 1 ? (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                style={{
                                                    fontSize: '15px',
                                                    fontWeight: 'bolder',
                                                    left: 0,
                                                    position: 'sticky',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {ele?._id?.year}
                                            </StyledTableCell>
                                        ) : (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    left: 0,
                                                    position: 'sticky',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {months[ele?.month]}-{ele?._id?.year % 100}
                                            </StyledTableCell>
                                        )}
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.leadReceivedData, "Lead Received")} style={clickableCellStyle(index)}>
                                            {ele.leadReceivedCount}
                                        </StyledTableCell>
                                        {/* <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.whatsAppChatInProgressData, "whatsAppChatInProgress")} style={clickableCellStyle(index)}>
                                            {ele.whatsAppChatInProgressCount}
                                        </StyledTableCell> */}
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.realLeadsData, "Real Leads")} style={clickableCellStyle(index)}>
                                            {ele.realLeadsCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.ntbcHoldData, "NTBC - Hold")} style={clickableCellStyle(index)}>
                                            {ele.ntbcHoldCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.holdData, "Hold")} style={clickableCellStyle(index)}>
                                            {ele.holdCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.junkData, "Junk")} style={clickableCellStyle(index)}>
                                            {ele.junkCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.toBeCalledData, "To Be Called")} style={clickableCellStyle(index)}>
                                            {ele.toBeCalledCount}
                                        </StyledTableCell>
                                        {/* <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.grandTotalData, "total")} style={grandTotalCellStyle}>
                                            {ele.totalCount}
                                        </StyledTableCell> */}
                                    </StyledTableRow>
                                ))
                            ) : (
                                [...Array(2)].map((_, rowIdx) => (
                                    <StyledTableRow key={rowIdx}>
                                        {[...Array(7)].map((__, colIdx) => (
                                            <StyledTableCell key={colIdx}>
                                                <Skeleton variant="text" width="100%" style={{ backgroundColor: 'white' }} />
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))
                            )}
                        </TableHead>
                    </Table>
                </TableContainer>
            </Paper>

            <Paper
                elevation={3}
                style={{
                    padding: "20px",
                    marginTop: "20px",
                    borderRadius: "10px",
                    backgroundColor: "#fafafa",
                    marginTop: "20px"
                }}
            >

                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #e0e0e0",
                        paddingBottom: "10px",
                        marginBottom: "20px"
                    }}
                >
                    <h3
                        style={{
                            margin: 0,
                            fontWeight: 600,
                            color: "#1C375D",
                            letterSpacing: "0.5px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <AutorenewIcon style={{ fontSize: 22 }} />
                        Automation Real Leads Bifurcation  {breakdownLoading && <CircularProgress size={18} />}
                    </h3>

                    <CSVLink
                        data={automationLeadBreakdownTableCsvData}
                        filename={`Automation_Lead_Breakdown_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={automationLeadBreakdownTableCsvButtonRef}
                        style={{ display: "none" }}
                    />

                    <Button
                        variant="contained"
                        startIcon={<DownloadOutlined />}
                        disabled={breakdownLoading}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            const csvData = generateAutomationLeadBreakdownTableCsvData();

                            if (csvData.length > 0) {
                                setAutomationLeadBreakdownTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerBreakdownDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.5rem 1.8rem",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: "0px 3px 8px rgba(0,0,0,0.15)"
                        }}
                    >
                        Download CSV
                    </Button>
                </div>
                {/* TABLE */}
                <TableContainer
                    style={{
                        maxHeight: "600px",
                        overflow: "auto"
                    }}
                    classes={{ root: classes.customTableContainer }}
                >
                    <Table style={{ minWidth: '400px' }}>
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                            <StyledTableRow>
                                <StyledTableCell
                                    className={classes.bordercolors}
                                    style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: 'center', fontWeight: 'bold' }}
                                >
                                    Real Leads
                                </StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Automation Leads
                                </StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    BotWot Leads
                                </StyledTableCell>
                            </StyledTableRow>
                        </TableHead>

                        <TableBody>
                            {
                                breakdownLoading ? (
                                    [...Array(2)].map((_, rowIdx) => (
                                        <StyledTableRow key={rowIdx}>
                                            {[...Array(3)].map((__, colIdx) => (
                                                <StyledTableCell key={colIdx}>
                                                    <Skeleton variant="text" width="100%" style={{ backgroundColor: 'white' }} />
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    ))
                                ) : store.length > 0 ? (

                                    store.map((ele, index) => {

                                        const automationLeads = ele.realLeadsData?.filter(
                                            (lead) => lead.automationLead === true && !lead.botWot
                                        ) || [];

                                        const botWotLeads = ele.realLeadsData?.filter(
                                            (lead) => lead.automationLead === true && lead.botWot
                                        ) || [];

                                        return (
                                            <StyledTableRow key={index}>

                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={clickableCellStyle(index)}
                                                    onClick={() => dataBasedOnClick(ele.realLeadsData, 'Real Leads')}
                                                >
                                                    {ele.realLeadsCount}
                                                </StyledTableCell>

                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={clickableCellStyle(index)}
                                                    onClick={() => dataBasedOnClick(automationLeads, 'Automation Leads')}
                                                >
                                                    {automationLeads.length}
                                                </StyledTableCell>

                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={clickableCellStyle(index)}
                                                    onClick={() => dataBasedOnClick(botWotLeads, 'BotWot Leads')}
                                                >
                                                    {botWotLeads.length}
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        );
                                    })

                                ) : (

                                    [...Array(2)].map((_, rowIdx) => (
                                        <StyledTableRow key={rowIdx}>
                                            {[...Array(3)].map((__, colIdx) => (
                                                <StyledTableCell key={colIdx}>
                                                    <Skeleton variant="text" width="100%" />
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    ))

                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            <Paper
                elevation={3}
                style={{
                    padding: "20px",
                    marginTop: "20px",
                    borderRadius: "10px",
                    backgroundColor: "#fafafa"
                }}
            >

                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #e0e0e0",
                        paddingBottom: "10px",
                        marginBottom: "20px"
                    }}
                >
                    <h3
                        style={{
                            margin: 0,
                            fontWeight: 600,
                            color: "#1C375D",
                            letterSpacing: "0.5px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <PersonAddIcon style={{ fontSize: 22 }} />
                        Manual Leads {manualLoading && <CircularProgress size={18} />}
                    </h3>

                    <CSVLink
                        data={manualLeadTableCsvData}
                        filename={`Manual_Lead_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={manualLeadTableCsvButtonRef}
                        style={{ display: "none" }}
                    />

                    <Button
                        variant="contained"
                        startIcon={<DownloadOutlined />}
                        disabled={manualLoading}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            const csvData = generateManualLeadTableCsvData();

                            if (csvData.length > 0) {
                                setManualLeadTableCsvData(csvData);
                                setTimeout(() => {
                                    setTriggerManualDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.5rem 1.8rem",
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: "0px 3px 8px rgba(0,0,0,0.15)"
                        }}
                    >
                        Download CSV
                    </Button>
                </div>


                {/* TABLE */}
                <TableContainer
                    style={{
                        maxHeight: "600px",
                        overflow: "auto"
                    }}
                    classes={{ root: classes.customTableContainer }}
                >
                    <Table style={{ minWidth: "600px" }}>
                        {/* Static Headers */}
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                            <StyledTableRow>
                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }} rowSpan={2}>
                                    Month And Year
                                </StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Lead Received</StyledTableCell>
                                {/* <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>WhatsApp Chat In Progress</StyledTableCell> */}
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Real</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>NTBC -Hold</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Hold</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>Junk</StyledTableCell>
                                <StyledTableCell className={classes.bordercolors} style={{ textAlign: 'center' }}>To Be Called</StyledTableCell>
                                {/* <StyledTableCell className={classes.bordercolors} style={{ fontSize: '15px', textAlign: 'center' }}>
                                    Grand Total
                                </StyledTableCell> */}
                            </StyledTableRow>
                        </TableHead>
                        <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                            {manualLoading ? (
                                [...Array(2)].map((_, rowIdx) => (
                                    <StyledTableRow key={rowIdx}>
                                        {[...Array(7)].map((__, colIdx) => (
                                            <StyledTableCell key={colIdx}>
                                                <Skeleton variant="text" width="100%" style={{ backgroundColor: 'white' }} />
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))
                            ) : storeManual.length > 0 ? (
                                storeManual.map((ele, index) => (
                                    <StyledTableRow key={index}>
                                        {index === storeManual.length - 1 ? (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                style={{
                                                    fontSize: '15px',
                                                    fontWeight: 'bolder',
                                                    left: 0,
                                                    position: 'sticky',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {ele?._id?.year}
                                            </StyledTableCell>
                                        ) : (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'normal',
                                                    left: 0,
                                                    position: 'sticky',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {months[ele?.month]}-{ele?._id?.year % 100}
                                            </StyledTableCell>
                                        )}
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.leadReceivedData, "Lead Received")} style={clickableCellStyle(index)}>
                                            {ele.leadReceivedCount}
                                        </StyledTableCell>
                                        {/* <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.whatsAppChatInProgressData, "whatsAppChatInProgress")} style={clickableCellStyle(index)}>
                                            {ele.whatsAppChatInProgressCount}
                                        </StyledTableCell> */}
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.realLeadsData, "Real Leads")} style={clickableCellStyle(index)}>
                                            {ele.realLeadsCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.ntbcHoldData, "NTBC - Hold")} style={clickableCellStyle(index)}>
                                            {ele.ntbcHoldCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.holdData, "Hold")} style={clickableCellStyle(index)}>
                                            {ele.holdCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.junkData, "Junk")} style={clickableCellStyle(index)}>
                                            {ele.junkCount}
                                        </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.toBeCalledData, "To Be Called")} style={clickableCellStyle(index)}>
                                            {ele.toBeCalledCount}
                                        </StyledTableCell>
                                        {/* <StyledTableCell className={classes.bordercolors} onClick={(e) => dataBasedOnClick(ele.grandTotalData, "total")} style={grandTotalCellStyle}>
                                            {ele.totalCount}
                                        </StyledTableCell> */}
                                    </StyledTableRow>
                                ))
                            ) : (
                                [...Array(2)].map((_, rowIdx) => (
                                    <StyledTableRow key={rowIdx}>
                                        {[...Array(7)].map((__, colIdx) => (
                                            <StyledTableCell key={colIdx}>
                                                <Skeleton variant="text" width="100%" style={{ backgroundColor: 'white' }} />
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                ))
                            )}
                        </TableHead>
                    </Table>
                </TableContainer>
            </Paper>

            <Modal
                open={showDetailedModal}
                onClose={handleCloseModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 300,
                    style: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                        backdropFilter: "blur(4px)"
                    }
                }}
            >
                <Fade in={showDetailedModal}>
                    <div
                        style={{
                            width: "95%",
                            height: "90vh",
                            margin: "auto",
                            marginTop: "2%",
                            background: "#fff",
                            borderRadius: 12,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column"
                        }}
                    >

                        {/* HEADER */}
                        <div
                            style={{
                                padding: "15px 20px",
                                background: "linear-gradient(90deg, #4f46e5, #9333ea)",
                                color: "#fff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            <div>
                                <Typography style={{ fontWeight: 600 }}>
                                    {pivot}
                                </Typography>
                                <Typography style={{ fontSize: 12 }}>
                                    {filteredData.length} leads found
                                </Typography>
                            </div>

                            <div style={{ display: "flex", gap: 10 }}>
                                <CSVLink
                                    headers={headers}
                                    filename={`${pivot}.csv`}
                                    data={csvData}
                                    ref={csvButtonRef}
                                >
                                    {!isMarketingAnalyst &&
                                        <Button
                                            onClick={() => csvDownloadHandler(popMonthData)}
                                            startIcon={<GetAppIcon />}
                                            style={{
                                                color: "#fff",
                                                border: "1px solid #fff"
                                            }}
                                        >
                                            Export
                                        </Button>
                                    }
                                </CSVLink>

                                <IconButton
                                    onClick={handleCloseModal}
                                    style={{ color: "#fff" }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>

                        {/* SEARCH */}
                        <div style={{ padding: 15 }}>
                            <TextField
                                placeholder="Search leads..."
                                variant="outlined"
                                size="small"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setPage(0);
                                }}
                                style={{ width: 300 }}
                            />
                        </div>

                        {/* TABLE / LOADER */}
                        <div style={{ flex: 1, overflow: "auto" }}>
                            {modalLoading ? (
                                <div
                                    style={{
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                >
                                    <CircularProgress size={50} />
                                </div>
                            ) : filteredData.length === 0 ? (
                                <p style={{ textAlign: "center", marginTop: 20 }}>
                                    No data found
                                </p>
                            ) : (
                                <Table stickyHeader>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell>Sl. No.</StyledTableCell>
                                            <StyledTableCell>Lead No.</StyledTableCell>
                                            <StyledTableCell>Client</StyledTableCell>
                                            <StyledTableCell>Stage</StyledTableCell>
                                            <StyledTableCell>Type</StyledTableCell>
                                            <StyledTableCell>City</StyledTableCell>
                                            <StyledTableCell>Exp Center</StyledTableCell>
                                            <StyledTableCell>CreatedAt</StyledTableCell>
                                            <StyledTableCell>Assigned Date</StyledTableCell>
                                            <StyledTableCell>Assigned To</StyledTableCell>
                                            <StyledTableCell>Source</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>

                                    <TableBody>
                                        {paginatedData.map((data, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell component="th" align="center">
                                                    {page * rowsPerPage + index + 1}
                                                </StyledTableCell>

                                                <StyledTableCell component="th" align="center">
                                                    {data?.lead_no ? (
                                                        <Link
                                                            to={`/project-logs/${data?._id}`}
                                                            target="_blank"
                                                            style={{ textDecoration: "underline" }}
                                                        >
                                                            {data.lead_no}
                                                        </Link>
                                                    ) : "NA"}
                                                </StyledTableCell>

                                                <StyledTableCell component="th" align="center">{data?.customerName || "NA"}</StyledTableCell>
                                                <StyledTableCell component="th" align="center">{data?.currentStage || "NA"}</StyledTableCell>
                                                <StyledTableCell component="th" align="center">{data?.leadType || "NA"}</StyledTableCell>
                                                <StyledTableCell component="th" align="center">{data?.cityName || "NA"}</StyledTableCell>
                                                <StyledTableCell component="th" align="center">{data?.experienceCenterName || "NA"}</StyledTableCell>

                                                <StyledTableCell component="th" align="center">
                                                    {data?.createdAt
                                                        ? moment(data.createdAt).format("DD-MM-YYYY")
                                                        : "NA"}
                                                </StyledTableCell>

                                                <StyledTableCell component="th" align="center">
                                                    {data?.leadAssignedDate
                                                        ? moment(data.leadAssignedDate).format("DD-MM-YYYY")
                                                        : "NA"}
                                                </StyledTableCell>

                                                <StyledTableCell component="th" align="center">{data?.assignedPerson || "NA"}</StyledTableCell>
                                                <StyledTableCell component="th" align="center">{data?.sourceOfLead || "NA"}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}
                        </div>

                        {/* PAGINATION */}
                        {!modalLoading && filteredData.length > 0 && (
                            <div
                                style={{
                                    padding: 10,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >
                                <Typography style={{ fontSize: 12 }}>
                                    Showing {page * rowsPerPage + 1} -{" "}
                                    {Math.min((page + 1) * rowsPerPage, filteredData.length)} of{" "}
                                    {filteredData.length}
                                </Typography>

                                <div>
                                    <IconButton
                                        disabled={page === 0}
                                        onClick={() => setPage((p) => p - 1)}
                                    >
                                        <ArrowBackIosIcon fontSize="small" />
                                    </IconButton>

                                    <span style={{ margin: "0 10px" }}>
                                        Page {page + 1} of{" "}
                                        {Math.ceil(filteredData.length / rowsPerPage)}
                                    </span>

                                    <IconButton
                                        disabled={(page + 1) * rowsPerPage >= filteredData.length}
                                        onClick={() => setPage((p) => p + 1)}
                                    >
                                        <ArrowForwardIosIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>
                        )}
                    </div>
                </Fade>
            </Modal>
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(AutomationLeadDashboard);
